import { CONCILIATION_STATUS, getStatusDescription } from '@/types'
import { Vue } from 'vue-property-decorator'
import { VChip } from 'vuetify/lib'

export const ChipStatusReconciliation = Vue.extend({
	extends: VChip,
	name: 'ChipStatusReconciliation',
	props: {
		reconStatus: {
			type: Number,
			required: false,
			default: 0
		}
	},

	computed: {
		attributes(): any {
			let currentReconStatus = Number(this.reconStatus)

			switch (currentReconStatus) {
				case CONCILIATION_STATUS.NOT_STARTED:
					return {
						color: 'transparent',
						textColor: '#6E6E64',
						description: getStatusDescription(currentReconStatus)
					}

				case CONCILIATION_STATUS.NOT_FOUND_BANK:
					return {
						color: '#FFF8E6',
						textColor: '#000000',
						description: getStatusDescription(currentReconStatus)
					}

				case CONCILIATION_STATUS.NOT_FOUND_ISOLVE:
					return {
						color: '#FCEFCD',
						textColor: '#000000',
						description: getStatusDescription(currentReconStatus)
					}

				case CONCILIATION_STATUS.INVALID:
				case CONCILIATION_STATUS.INCORRECT_STATUS:
				case CONCILIATION_STATUS.CONTESTED:
				case CONCILIATION_STATUS.DISPUTED_VALUE:
				case CONCILIATION_STATUS.NOT_PAYABLE:
					return {
						color: '#FFE9E6',
						textColor: '#000000',
						description: getStatusDescription(currentReconStatus)
					}

				case CONCILIATION_STATUS.VALID:
				case CONCILIATION_STATUS.VALID_WITH_AUTOMATIC_CORRECTION:
				case CONCILIATION_STATUS.VALID_WITHOUT_DOCUMENT:
					return {
						color: '#DBFFD9',
						textColor: '#000000',
						description: getStatusDescription(CONCILIATION_STATUS.VALID)
					}
					
				case CONCILIATION_STATUS.VALIDATED_MANUALLY:
					return {
						color: '#DBFFD9',
						textColor: '#000000',
						description: getStatusDescription(CONCILIATION_STATUS.VALIDATED_MANUALLY)
					}

				default:
					return {
						description: '-',
						color: 'transparent'
					}
			}
		}
	},

	render() {
		return (
			<VChip small {...{ attrs: this.attributes }}>
				{this.attributes?.description}
			</VChip>
		)
	}
})

export default ChipStatusReconciliation
